/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoCorrezioneSpuntaForm } from './documento-correzione-spunta-form';


export interface DocumentoCorrezioneForm { 
    titolo_it: string;
    testo_it: string;
    spunte: Array<DocumentoCorrezioneSpuntaForm>;
    version: number;
}

